import { render, staticRenderFns } from "./commonImgEnlarge.vue?vue&type=template&id=50deddff&scoped=true"
import script from "./commonImgEnlarge.vue?vue&type=script&lang=js"
export * from "./commonImgEnlarge.vue?vue&type=script&lang=js"
import style0 from "./commonImgEnlarge.vue?vue&type=style&index=0&id=50deddff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50deddff",
  null
  
)

export default component.exports